var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoClosed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1293_7269)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#12263E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.5V32.5H19.4297V24.6429H23.1571C25.6064 24.6429 27.6653 23.8214 29.3338 22.1429C31.0022 20.4643 31.8542 18.4643 31.8542 16.0714C31.8542 13.6786 31.0022 11.6786 29.3338 10C27.6653 8.32143 25.6064 7.5 23.1571 7.5H13.75ZM19.4297 19.2857V12.8571H23.1571C24.8965 12.8571 26.1744 14.25 26.1744 16.0714C26.1744 17.8929 24.8965 19.2857 23.1571 19.2857H19.4297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7552 31.2448C53.7483 36.0992 53.7483 43.8662 48.7552 48.8592C43.9008 53.7136 36.1338 53.7136 31.1408 48.8592C26.2864 43.8662 26.2864 36.0992 31.1408 31.2448C36.1338 26.2517 43.9008 26.2517 48.7552 31.2448Z",
    fill: "#2B63E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7552 3.7448C8.74827 8.59916 8.74827 16.3662 3.7552 21.3592C-1.09917 26.2136 -8.86616 26.2136 -13.8592 21.3592C-18.7136 16.3662 -18.7136 8.59916 -13.8592 3.7448C-8.86616 -1.24827 -1.09917 -1.24827 3.7552 3.7448Z",
    fill: "#00C9BD"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 9.5,
    stroke: "#3C4F65"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1293_7269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClosed);
export default __webpack_public_path__ + "static/media/logo-closed.7760d8e1a996ed4558182a5196ec9575.svg";
export { ForwardRef as ReactComponent };